<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">每天色卡清单列表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1" :style="{ marginRight: '24px' }">
            <span class="label">时间</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="YYYY-MM-DD"
            />
          </div>
          <div class="item col-1">
            <div class="label" style="width: 117px">用户名/手机微信:</div>
            <label
              ><input
                type="text"
                style="width: 200px"
                class="cg-input"
                v-model="phone"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">品名</div>
            <el-select
              v-model="pmname"
              placeholder="请选择品名"
              style="width: 120px"
              clearable
              filterable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" @click="search" class="custom-btn"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column align="center" width="100" label="日期">
        <template #default="scope">
          {{ formatDate(scope.row.date) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="phone"
        width="130"
        label="用户名/手机微信"
      />
      <el-table-column
        align="center"
        label="联系方式"
        width="280"
        show-overflow-tooltip
      >
        <template #default="scope">
          {{ scope.row.phone + "," + scope.row.address }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="取件方式"
        width="80"
        show-overflow-tooltip
      >
        <template #default="scope">
          {{ typelist[scope.row.type - 1].name }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        show-overflow-tooltip
        prop="productNameDisplay"
        label="拿色卡清单"
      />
      <el-table-column align="center" label="操作" width="100">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 色卡修改弹窗 -->
    <el-dialog
      title="色卡清单修改"
      center
      width="500px"
      v-model="dialogTableVisible"
    >
      <div class="dialog-content">
        <div class="user-info">用户：{{ currentRow?.phone }}</div>
        <div class="table-header">
          <span style="width: 75%; text-align: center">品名</span>
          <span style="width: 15%">数量</span>
          <span style="width: 10%">操作</span>
        </div>
        <div class="table-body">
          <div
            class="row-item"
            v-for="(item, index) in editList"
            :key="item.id || index"
          >
            <div class="product-name-select">
              <el-select
                filterable
                clearable
                v-model="item.productId"
                :disabled="item.delflag === 0"
                @change="(val) => handleProductChange(index, val)"
                placeholder="选择品名"
              >
                <el-option
                  v-for="p in pmlist"
                  :key="p.id"
                  :label="p.name"
                  :value="p.id"
                ></el-option>
              </el-select>
            </div>
            <div class="num-input-wrap">
              <input
                type="number"
                class="num-input"
                v-model.number="item.number"
                :disabled="item.delflag === 0"
                min="1"
              />
            </div>
            <span v-if="item.delflag === 0" class="del-btn disabled">
              已删除
            </span>
            <span
              v-else
              class="el-icon-close"
              style="font-size: 22px; cursor: pointer"
              @click="handleDelete(index)"
            ></span>
          </div>
          <div class="add-row">
            <el-select
              v-model="newProductId"
              placeholder="选择品名"
              clearable
              filterable
              @clear="newProductId = ''"
            >
              <el-option
                v-for="p in pmlist"
                :key="p.id"
                :label="p.name"
                :value="p.id"
              ></el-option>
            </el-select>
            <span class="add-btn" @click="handleAddProduct">+</span>
          </div>
        </div>
        <div class="footer">
          <el-button type="primary" class="custom-btn" @click="save"
            >调整保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();
const dateRange = ref([]);
const dialogTableVisible = ref(false);
const phone = ref("");
const list = ref([]);
const pmname = ref("");
const pmlist = ref([]);
const currentRow = ref(null);
const editList = ref([]);
const newProductId = ref("");
const typelist = ref([{ name: "到店取" }, { name: "快递送" }]);
// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardDailyList";

//获取近一周日期范围
const getDefaultDateRange = () => {
  const today = new Date();
  const weekAgo = new Date();
  weekAgo.setDate(today.getDate() - 7);
  const format = (d) => {
    const y = d.getFullYear();
    const m = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  return [format(weekAgo), format(today)];
};

watch([dateRange, phone, pmname], () => {
  const searchParams = {
    phone: phone.value,
    dateRange: dateRange.value,
    pmname: pmname.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      // 判断缓存dateRange是否存在且数组长度大于0，否则用默认一周
      if (
        cache.dateRange &&
        Array.isArray(cache.dateRange) &&
        cache.dateRange.length === 2
      ) {
        dateRange.value = cache.dateRange;
      } else {
        dateRange.value = getDefaultDateRange();
      }
      pmname.value = cache.pmname ?? "";
      phone.value = cache.phone ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
      // 解析失败也默认一周
      dateRange.value = getDefaultDateRange();
    }
  } else {
    // 无缓存时默认一周
    dateRange.value = getDefaultDateRange();
  }
};

const formatDate = (date) => {
  if (!date) return "";
  const time = new Date(date);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const day = time.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    } else {
      proxy.$message.error("获取产品列表失败");
      pmlist.value = [];
    }
  } catch (error) {
    proxy.$message.error("网络错误，获取产品列表失败");
    pmlist.value = [];
  }
};
const search = async () => {
  getList();
};
const getList = async () => {
  const beginTime = dateRange.value?.[0] || "";
  const endTime = dateRange.value?.[1] || "";
  const sendata = {
    productId: pmname.value,
    phone: phone.value,
    beginTime,
    endTime,
  };
  try {
    const res = await proxy.$api.Colorcard.getDaily(sendata);
    if (res.data.code == 200) {
      list.value = res.data.data.list;
    } else {
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
      list.value = [];
    }
  } catch (error) {
    proxy.$message.error("网络错误，获取列表失败");
    list.value = [];
  }
};
const up = (row) => {
  currentRow.value = row;
  editList.value = row.infoList.map((item) => ({
    ...item,
    delflag: item.delflag ?? 1,
  }));
  dialogTableVisible.value = true;
};
const handleProductChange = (index, productId) => {
  const product = pmlist.value.find((p) => p.id === productId);
  if (product) {
    editList.value[index].productName = product.name;
  }
};
const handleDelete = (index) => {
  editList.value[index].delflag = 0;
};
const handleAddProduct = () => {
  if (!newProductId.value) {
    proxy.$message.warning("请先选择品名");
    return;
  }
  const product = pmlist.value.find((p) => p.id === newProductId.value);
  if (!product) return;
  editList.value.push({
    productId: product.id,
    productName: product.name,
    number: 1,
    storeId: currentRow.value.infoList[0]?.storeId || "",
    storeName: currentRow.value.infoList[0]?.storeName || "",
    id: "",
    delflag: 1,
  });
  newProductId.value = "";
};
const save = async () => {
  // 校验：下方新增行选中了品名，但没按加号添加
  if (newProductId.value) {
    proxy.$message.warning("您已选择品名，请点击【+】添加数量后再保存！");
    return;
  }

  // 可选再加一条：校验现有条目数量不能为空或者0
  const hasEmptyNum = editList.value.some(
    (item) => !item.number || item.number <= 0
  );
  if (hasEmptyNum) {
    proxy.$message.warning("品名数量要大于0!");
    return;
  }

  const sendata = {
    id: currentRow.value.id,
    infoList: editList.value.map((item) => ({
      id: item.id || undefined,
      productId: item.productId,
      number: item.number,
      storeId: item.storeId,
      delflag: item.delflag,
    })),
  };
  try {
    const res = await proxy.$api.Colorcard.upDaily(sendata);
    if (res.data.code == 200) {
      dialogTableVisible.value = false;
      proxy.$message.success("修改成功");
      getList();
    } else {
      proxy.$message.error("修改失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    proxy.$message.error("网络错误，修改失败");
  }
};

onMounted(() => {
  pmList();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./colorcardDailyList.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin: 0 auto !important; // 关键：不能只清 margin-top，底部的 50px 也要清掉
  height: 100vh !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
:deep(.el-dialog__header) {
  flex-shrink: 0; // 标题栏固定，不参与滚动
}

:deep(.el-dialog--center .el-dialog__body) {
  padding: 0 20px 20px;
  flex: 1;
  overflow: hidden; // 原来是 overflow-y: auto，现在改成 hidden
}
:deep(.el-dialog__title) {
  color: black;
  font-weight: 700;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper,
  .el-table__header th,
  .el-table__body-wrapper,
  .el-table__body td {
    background-color: #fff !important;
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
.dialog-content {
  height: 100%; // 占满 body
  display: flex;
  flex-direction: column;
  .user-info {
    font-size: 18px;
    color: #333;
    text-align: left;
    margin-bottom: 18px;
  }
  .table-header {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
    padding: 0 5px;
    span {
      width: 30%;
      text-align: center;
      &:first-child {
        text-align: left;
      }
      &:last-child {
        text-align: right;
      }
    }
  }
  .footer {
    flex-shrink: 0; // 固定，不参与滚动
  }
  .table-body {
    flex: 1; // 占据剩余空间
    min-height: 0; // 关键！flex 子项默认不能收缩出滚动，必须加这个
    overflow-y: auto; // 滚动条只出现在行列表区域
    .row-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      padding: 0 5px;
      .product-name-select {
        width: 70%;
        :deep(.el-select) {
          width: 100%;
        }
      }
      .num-input-wrap {
        width: 15%;
        display: flex;
        align-items: center;
        justify-content: center;
        .num-input {
          width: 40px;
          text-align: center;
          border: none;
          border-bottom: 1px solid #999;
          font-size: 18px;
          outline: none;
        }
      }
      .del-btn {
        width: 15%;
        text-align: right;
        font-size: 20px;
        color: #409eff;
        cursor: pointer;
        &.disabled {
          color: #999;
          cursor: not-allowed;
          font-size: 14px;
        }
      }
    }
    .add-row {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-top: 10px;
      padding: 0 5px;
      :deep(.el-select) {
        width: 120px;
      }
      .add-btn {
        font-size: 20px;
        color: #409eff;
        cursor: pointer;
      }
    }
  }
  .footer {
    margin-top: 20px;
    text-align: center;
    :deep(.el-button) {
      background-color: #ffd04b;
      color: #333;
      border: none;
      &:hover {
        background-color: #ffc72c;
      }
    }
  }
}
</style>
